import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex justify-content-center",
  style: {"padding-top":"200px"}
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "btn btn-secondary" }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "btn btn-light mr-auto" }
const _hoisted_10 = {
  class: "container",
  style: {"padding-top":"80px"}
}
const _hoisted_11 = { id: "MeetingQuestion" }
const _hoisted_12 = { style: {"min-height":"100vh","margin-top":"80px"} }
const _hoisted_13 = {
  class: "text-center lead",
  style: {"font-size":"1.5rem"}
}
const _hoisted_14 = { style: {"min-height":"450px"} }
const _hoisted_15 = {
  key: 0,
  class: "mt-4",
  style: {"min-height":"500px"}
}
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "btn btn-light mr-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeDetailsDialog = _resolveComponent("AlternativeDetailsDialog")!
  const _component_AttributeDescriptionDialog = _resolveComponent("AttributeDescriptionDialog")!
  const _component_PanelistVoteEditor = _resolveComponent("PanelistVoteEditor")!
  const _component_VotesBrowser = _resolveComponent("VotesBrowser")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlternativeDetailsDialog, { viewModel: _ctx.alternativeDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AttributeDescriptionDialog, { viewModel: _ctx.attributeDescriptionDialog }, null, 8 /* PROPS */, ["viewModel"]),
    (!_ctx.Initialized || _ctx.Connecting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
          _createStaticVNode("<div class=\"card\"><div class=\"card-body\"><h5 class=\"card-title\"><i class=\"fa fa-spinner fa-spin\"></i> Connecting...</h5><p class=\"card-text lead\">We are checking if meeting was started by the host.</p><br></div></div>", 1)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.Initialized && !_ctx.Connecting && !_ctx.MeetingStarted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "card-title" }, "Meeting is not started", -1 /* CACHED */)),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "card-text lead" }, "Please wait for the host to start this meeting.", -1 /* CACHED */)),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Go to the survey mode", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.DashboardUrl]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.Initialized && !_ctx.Connecting && _ctx.MeetingStarted && _ctx.EligibleQuestion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("nav", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("i", {
                  class: "fa fa-angle-double-left",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" My Survey ", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.DashboardUrl]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, [
                  _cache[8] || (_cache[8] = _createTextVNode(" How would you rate: ", -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "text-primary",
                    title: "Show description",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ShowAlternativeDetailsCommand && _ctx.ShowAlternativeDetailsCommand(...args)))
                  }, _toDisplayString(_ctx.AlternativeName), 1 /* TEXT */),
                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _cache[10] || (_cache[10] = _createTextVNode(" in the context of: ", -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "text-primary",
                    title: "Show description",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.ShowAttributeDetailsCommand && _ctx.ShowAttributeDetailsCommand(...args)))
                  }, _toDisplayString(_ctx.AttributeName), 1 /* TEXT */),
                  _cache[11] || (_cache[11] = _createTextVNode("? ", -1 /* CACHED */))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_PanelistVoteEditor, {
                    comment: _ctx.voteComment,
                    value: _ctx.voteValue,
                    scaleLevels: _ctx.Question.ScaleLevels,
                    onUpdateComment: _ctx.handleUpdateComment,
                    onUpdateValue: _ctx.handleUpdateValue
                  }, null, 8 /* PROPS */, ["comment", "value", "scaleLevels", "onUpdateComment", "onUpdateValue"])
                ]),
                (_ctx.Question?.Entries != null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_VotesBrowser, {
                        AlternativeName: _ctx.Question.AlternativeName,
                        HasScale: _ctx.Question.HasScale,
                        Entries: _ctx.Question.Entries,
                        ScaleLevels: _ctx.Question.ScaleLevels
                      }, null, 8 /* PROPS */, ["AlternativeName", "HasScale", "Entries", "ScaleLevels"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.Initialized && !_ctx.Connecting && _ctx.MeetingStarted && !_ctx.EligibleQuestion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("nav", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_19, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", {
                  class: "fa fa-angle-double-left",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" My Survey ", -1 /* CACHED */)
              ]))])), [
                [_directive_sanitizedHref, _ctx.DashboardUrl]
              ])
            ])
          ]),
          _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"container\" style=\"padding-top:80px;\"><div id=\"MeetingQuestion\"><div style=\"min-height:100vh;margin-top:80px;\"><div class=\"d-flex justify-content-center\"><div class=\"card\"><div class=\"card-body\"><h5 class=\"card-title\">Sorry, you are not selected to answer this question.</h5><p class=\"card-text lead\">Please wait for another question.</p><!--&lt;p&gt;\n                                    How would you rate: &lt;a class=&quot;text-primary&quot; title=&quot;Show description&quot; @click=&quot;ShowAlternativeDetailsCommand&quot;&gt;{{AlternativeName}}&lt;/a&gt;\n                                    in the context of: &lt;a class=&quot;text-primary&quot; title=&quot;Show description&quot; @click=&quot;ShowAttributeDetailsCommand&quot;&gt;{{AttributeName}}&lt;/a&gt;?\n                                &lt;/p&gt;--></div></div></div></div> iv </div></div>", 1))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}